import script from "./catalogItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./catalogItem.vue?vue&type=script&setup=true&lang=ts"

import "./catalogItem.vue?vue&type=style&index=0&id=6e9ed7a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e9ed7a4"]])

export default __exports__